import React from 'react'

import Seo from '@salesforce/retail-react-app/app/components/seo'

import { useTranslationHelpers } from '@epmc-mach/accelarator/overrides/app/hooks'

export const SeoContainer = ({ isCheckout = true }) => {
    const { tCheckoutPage, tConfirmationPage } = useTranslationHelpers()

    return (
        <Seo>
            <meta
                name="description"
                content={isCheckout ? tCheckoutPage?.metaDesc : tConfirmationPage?.metaDesc}
            />
            <meta
                name="apple-mobile-web-app-title"
                content={isCheckout ? tCheckoutPage?.metaTitle : tConfirmationPage?.metaTitle}
            />
            <title>{isCheckout ? tCheckoutPage?.metaTitle : tConfirmationPage?.metaTitle}</title>
        </Seo>
    )
}
